import moment from "moment";

import { Select, DatePicker, Button, Spin, Tabs, Input } from "antd";
import React, { useState, useEffect } from "react";
// import { useDispatch, useSelector } from "react-redux";
// import { useHistory } from "react-router-dom";
import * as XLSX from "xlsx";

import { getDataPost_2, getPDF_2 } from "../../../data/allfunction_2";
import { formatFloatNumber } from "../../../App";
import { pad } from "../../../data/allfunction";
const ip = process.env.REACT_APP_IP;
// const { TabPane } = Tabs;
const dateFormat = "DD-MM-YYYY";
const { Option } = Select;

// const data = [
//   { Name: 'John', Age: 28, Email: 'john@example.com' },
//   { Name: 'Jane', Age: 22, Email: 'jane@example.com' },
//   { Name: 'Mike', Age: 32, Email: 'mike@example.com' },
// ];

export default function ReportAllByAgentAndConId({ userRedux }) {
  const [datat_get, setdatat_get] = useState([]);
  const [data_for_excell, setdata_for_excell] = useState([]);
  const [cur, set_cur] = useState([]);
  const [datat_get_curr, setdatat_get_curr] = useState([]);
  const [user_id_get, setuser_id_get] = useState(0);
  const [loading, setloading] = useState(false);
  const [con_id, set_con_id] = useState("");

  const [total_con_pre_last, settotal_con_pre_last] = useState(0);
  const [total_con_total_pre_last, settotal_con_total_pre_last] = useState(0);
  const [total_con_com_money, settotal_con_com_money] = useState(0);
  const [total_con_tax_money, settotal_con_tax_money] = useState(0);
  const [total_zji_get, settotal_zji_get] = useState(0);

  //   console.log(userRedux);

  async function getPolicyNonMotor() {
    let rows = {
      agent_id: userRedux.agent_id,
      con_id,
    };
    console.log(rows);
    let l = ip + "non_motor/_3_by_con_id";
    let hpa_data = await getDataPost_2(
      l,
      rows,
      userRedux.token,
      userRedux.retoken
    );

    let currencies;

    if (hpa_data.data.length > 0) {
      setdatat_get(hpa_data.data);
      setdatat_get_curr([]);
      currencies = hpa_data.data.map((e) => {
        return e.op_day_cur;
      });
      set_cur([...new Set(currencies)]);
      setdata_for_excell(changeDataForExcellNonMotor(hpa_data.data));
    } else {
      setdatat_get([]);
      setdatat_get_curr([]);
      setdata_for_excell([]);
    }
  }

  useEffect(() => {
    let _total_con_pre_last = 0,
      _total_con_total_pre_last = 0,
      _total_con_com_money = 0,
      _settotal_con_tax_money = 0,
      _total_zji_get = 0;

    datat_get_curr.map((e) => {
      _total_con_pre_last += parseFloat(e.con_pre_last) || 0;
      _total_con_total_pre_last += parseFloat(e.con_total_pre_last) || 0;
      _total_con_com_money += parseFloat(e.con_com_money) || 0;
      _settotal_con_tax_money += parseFloat(e.con_tax_money) || 0;
      _total_zji_get += parseFloat(e.zji_get) || 0;
    });

    settotal_con_pre_last(_total_con_pre_last);
    settotal_con_total_pre_last(_total_con_total_pre_last);
    settotal_con_com_money(_total_con_com_money);
    settotal_con_tax_money(_settotal_con_tax_money);
    settotal_zji_get(_total_zji_get);
  }, [datat_get_curr]);

  return (
    <div>
      <div className="d-flex flex-row">
        <div className="flex-fill">
          <strong>ລະຫັດຕົວແທນ: {userRedux.user}</strong>
          <br />
          <strong>ຊື່ຕົວແທນ: {userRedux.name}</strong>
          <br />
        </div>
        <div className="flex-fill ml-2">
          <strong>ເລືອກປະເພດການຊຳລະຂອງສັນຍາ</strong>
          <Select
            placeholder="ເລືອກປະເພດການຊຳລະຂອງສັນຍາ"
            optionFilterProp="children"
            style={{ width: "100%" }}
            value={user_id_get}
            onChange={(e) => {
              console.log(e);
              setuser_id_get(e);
              // user_id_get 1 paid 0 not paid null all
            }}
          >
            <Option key={1} value={null}>
              {" "}
              ສັນຍາທັງໝົ້ດ{" "}
            </Option>
            <Option key={2} value={0}>
              {" "}
              ສັນຍາຄ້າງຈ່າຍ{" "}
            </Option>
            <Option key={3} value={1}>
              {" "}
              ສັນຍາຈ່າຍແລ້ວ{" "}
            </Option>
          </Select>
        </div>
      </div>
      <hr />
      <strong style={{ color: "red" }}>
        {" "}
        ພິມເລກທີສັນຍາ ສາມາດພິມໃນຮູບແບບ 1-5,9,15,20 (1-5 ແມ່ນເລືອກສັນຍາທີ 1 ຫາ
        ສັນຍາ ເລກທີ 5 )
      </strong>
      <div className="d-flex flex-row">
        <div className="flex-fill" style={{ marginRight: 10 }}>
          <Input
            style={{ width: "100%" }}
            placeholder="ພິມເລກທີສັນຍາ (ສາມາດພິມໃນຮູບແບບ 1-5,9,15,20)"
            onChange={(v) => {
              set_con_id(v.target.value);
            }}
          />
        </div>

        <Button
          // disabled={confirm}
          style={{ paddingLeft: 50, paddingRight: 50 }}
          onClick={() => {
            getPolicyNonMotor();
          }}
          type="primary"
        >
          {" "}
          ຄົ້ນຫາ{" "}
        </Button>
      </div>
      {loading && (
        <div
          style={{
            position: "absolute",
            top: "20%",
            left: "45%",
          }}
        >
          <Spin tip="ກຳລັງໂຫລດຂໍ້ມູນ..." />
        </div>
      )}
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
          marginTop: 10,
        }}
      >
        <div>
          <h5> ຈຳນວນສັນຍາທັງໝົ້ດ {datat_get.length} ສັນຍາ (ທຸກສະກຸນເງິນ)</h5>
        </div>
      </div>
      {/* {cur} */}
      ມີສະກຸນເງິນ (ກະລຸນາຄລິກທີ່ສະກຸນເງິນທີ່ຕ້ອງການກວດສອບ):{" "}
      {cur.map((e, i) => (
        <>
          <Button
            key={i}
            onClick={() => {
              console.log(e);
              let filteredData = datat_get.filter(
                (cur) => cur.op_day_cur === e
              );
              setdatat_get_curr(filteredData);
            }}
          >
            {e}
          </Button>{" "}
        </>
      ))}
      <table className="table table-striped">
        <thead>
          <tr>
            <th>#</th>
            <th>ເລກທີສັນຍາ</th>
            <th>ຊື່ສັນຍາ</th>
            <th>ວັນທີສ້າງສັນຍາ</th>
            <th>ປະເພດການຄຸ້ມກັນ</th>
            <th>ຊື່ແພັກແກັດ</th>
            <th>ຊື່ທາງເລືອກ</th>
            <th>ຈຳນວນວັນຄຸ້ມກັນ</th>
            <th>ວັນທີເລີ່ມຄຸ້ມກັນ</th>
            <th>ວັນທີສິ້ນສຸດຄຸ້ມກັນ</th>
            <th>ຄ່າທຳນຽມຕົ້ນ</th>
            <th>ຄ່າທຳນຽມທັງໝົ້ດ</th>
            <th>ຄ່າຄອມຕົວແທນ</th>
            <th>ຄ່າຄອມຕົວແທນຈ່າຍອາກອນ</th>
            <th>ເງິນ ZJI ໄດ້ຮັບ</th>
            <th>ສະກຸນເງິນ</th>
            <th>ການຊຳລະ</th>
          </tr>
        </thead>
        <tbody>
          {datat_get_curr.map((oneData, key) => {
            return (
              <tr key={key}>
                <td>{key + 1}</td>
                <td>
                  {/* {JSON.stringify(userRedux.token)}
                {JSON.stringify(userRedux.retoken)} */}
                  <ButtonDowloadPDFNonMotor
                    con_id={oneData.con_id}
                    token={userRedux.token}
                    retoken={userRedux.retoken}
                  />
                </td>
                <td>{oneData.con_name}</td>
                <td>{moment(oneData.con_create).format("DD-MM-YYYY")}</td>
                <td>{oneData.type_cov_name}</td>
                <td>{oneData.con_pac_name}</td>
                <td>{oneData.con_op_name}</td>
                <td>{oneData.con_day_name}</td>
                <td>{moment(oneData.con_start).format("DD-MM-YYYY")}</td>
                <td>{moment(oneData.con_end).format("DD-MM-YYYY")}</td>

                <td>{formatFloatNumber(oneData.con_pre_last)} </td>
                <td>{formatFloatNumber(oneData.con_total_pre_last)}</td>
                <td>
                  {oneData.con_com_last * 100}% ={" "}
                  {formatFloatNumber(oneData.con_com_money)}
                </td>

                <td>
                  {oneData.con_tax * 100}% ={" "}
                  {formatFloatNumber(oneData.con_tax_money)}
                </td>
                <td>{formatFloatNumber(oneData?.zji_get)}</td>
                <td>{oneData.op_day_cur}</td>
                <td>
                  {oneData.user_id_get == null ? (
                    <strong style={{ color: "red" }}> ຄ້າງຈ່າຍ </strong>
                  ) : (
                    "ຈ່າຍແລ້ວ"
                  )}
                </td>
              </tr>
            );
          })}
        </tbody>
        {datat_get_curr.length > 0 && (
          <tfoot>
            <tr>
              <th></th>
              <th></th>
              <th></th>
              <th></th>
              <th></th>
              <th></th>
              <th></th>
              <th></th>
              <th></th>
              <th></th>

              <th style={{ textAlign: "right" }}>
                {formatFloatNumber(total_con_pre_last)}
              </th>
              <th style={{ textAlign: "right" }}>
                {formatFloatNumber(total_con_total_pre_last)}
              </th>
              <th style={{ textAlign: "right" }}>
                {formatFloatNumber(total_con_com_money)}
              </th>
              <th style={{ textAlign: "right" }}>
                {formatFloatNumber(total_con_tax_money)}
              </th>
              <th style={{ textAlign: "right" }}>
                {formatFloatNumber(total_zji_get)}
              </th>

              <th></th>
              <th></th>
            </tr>
          </tfoot>
        )}
      </table>
      {data_for_excell.length > 0 && (
        <ExcelExportNonMotor data={data_for_excell} />
      )}
    </div>
  );
}

export function ExcelExportNonMotor({ data }) {
  const handleExport = () => {
    const worksheet = XLSX.utils.json_to_sheet(data);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
    const wbout = XLSX.write(workbook, { bookType: "xlsx", type: "binary" });
    const blob = new Blob([s2ab(wbout)], { type: "application/octet-stream" });
    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = "ExcelExportNonMotor.xlsx";
    link.click();
  };

  // Utility function to convert a string to an ArrayBuffer
  const s2ab = (s) => {
    const buf = new ArrayBuffer(s.length);
    const view = new Uint8Array(buf);
    for (let i = 0; i < s.length; i++) view[i] = s.charCodeAt(i) & 0xff;
    return buf;
  };

  return (
    <div>
      <Button onClick={handleExport}>ລາຍງານເປັນ Excel</Button>
    </div>
  );
}

export function showDateFomatLaos(date, moment) {
  return date == null ? null : moment(date).format("DD-MM-YYYY");
}

export function changeDataForExcellNonMotor(data) {
  return data.map((e) => {
    return {
      ປະເພດແພັກແກັດ: e.type_cov_name,
      ຊື່ແພັກແກັດ: e.pac_name,
      ເລກທີສັນຍາ: e.con_id,
      ຊື່ສັນຍາ: e.con_name,
      ວັນທີເລີ່ມຄຸ້ມກັນ: showDateFomatLaos(e.con_start, moment),
      ວັນທີສິ້ນສຸດການຄຸ້ມກັນ: showDateFomatLaos(e.con_end, moment),
      ວັນທີສ້າງສັນາ: showDateFomatLaos(e.con_create, moment),
      ຂອບເຂດພູມສັນຖານ: e.con_go,
      ຊື່ທາງເລືອກ: e.con_op_name,
      ຊື່ແພັກແກັດພາສາລາວ: e.con_pac_name,
      ຊື່ແພັກແກັດພາສາອັງກິດ: e.con_pac_name_e,
      ຈຳນວນວັນທີ່ຄຸ້ມກັນ: e.con_day_name,

      ຄ່າທຳນຽມຕົ້ນ: e.con_pre,
      ຄ່າທຳນຽມຕົ້ນທີ່ແກ້ໄຂ: e.con_pre_edit,
      ຄ່າທຳນຽມຕົ້ນສຸດທິ: e.con_pre_last,

      ຄ່າອາກອນຕົ້ນ: e.con_vat,
      ຄ່າອາກອນຕົ້ນທີ່ແກ້ໄຂ: e.con_vat_edit,
      ຄ່າອາກອນສຸດທິ: e.con_vat_last,

      ຄ່າຂື້ນທະບຽນ: e.con_op_day_re,

      ຄ່າທຳນຽມສຸດທ້າຍຕົ້ນ: e.con_total_pre,
      ຄ່າທຳນຽມສຸດທ້າຍທີ່ແກ້ໄຂ: e.con_total_pre_edit,
      ຄ່າທຳນຽມສຸດທິ: e.con_total_pre_last,

      ສະກຸນເງິນໃນສັນຍາ: e.op_day_cur,

      ລະຫັດແຂວງ: e.agent_AProvive,
      ລະຫັດຕົວແທນ: e.agent_Code,
      ຊື່ຕົວແທນ: e.agent_Surname,

      ຈຳນວນວັນທີ່ຄ້າງຈ່າຍ: e.day_diff,
      ຄ່າຄອມຕົວແທນ: e.con_com_last,
      ຄ່າຄອມຕົວແທນເປັນເງິນ: e.con_com_money,
      ຄ່າອາກອນລາຍໄດ້: e.con_tax,
      ຄ່າຄອມຕົວແທນທີ່ຫັກອາກອນລາຍໄດ້: e.con_tax_money,
      ຄ່າທຳນຽມທີ່ຈົງຈີໄດ້: e.zji_get,

      ເລກທີການຮັບເງິນ: e.receive_id,
      ລະຫັດພະນັກງານບັນຊີຕັດສັນຍາ: e.user_id_get,
      ວັນທີພະນັກງານບັນຊີຕັດສັນຍາ: showDateFomatLaos(e.con_date_get, moment),

      ລະຫັດພະນັກງານຍົກເລີ: e.user_id_cancle,
      ວັນທີພະນັກງານຍົກເລີກ: showDateFomatLaos(e.con_date_cancle, moment),

      ວັນທີຕົວແທນຈ່າຍເງິນ: showDateFomatLaos(e.receive_date_cust_paid, moment),
      ວັນທີພະນັກງານຮັບເງິນ: showDateFomatLaos(e.receive_date, moment),
      ໝາຍເຫດການຮັບເງິນ: e.receive_note,
      ສ້າງລາຍງານExcellວັນທີ: showDateFomatLaos(Date.now(), moment),
    };
  });
}

export function ButtonDowloadPDFNonMotor({ con_id, token, retoken }) {
  const [l, set_l] = useState(false);
  async function get_pdf_policy(no) {
    set_l(true);
    try {
      let l = ip + "non_motor/get_hpa_for_pdf_multi";
      let dataSetForGet = { con_id: no };
      let pro = await getPDF_2(l, dataSetForGet, token, retoken);

      // Create a temporary URL representing the Blob
      const url = window.URL.createObjectURL(pro);

      // Create a link element
      const a = document.createElement("a");
      a.href = url;
      a.download = pad(no);

      // Append the link to the body
      document.body.appendChild(a);

      // Trigger a click event on the link to initiate download
      a.click();

      // Cleanup
      window.URL.revokeObjectURL(url);
      document.body.removeChild(a);
      alert(
        "ດາວໂຫລດສັນຍາເລກທີ " + pad(no) + " ສຳເຫຼັ້ດກະລຸນາກວດສອບໂຟເດີ້ ດາວໂຫລດ"
      );
    } catch (error) {
      console.log(error);
    } finally {
      set_l(false);
    }
  }

  return (
    <Button
      loading={l}
      onClick={() => {
        get_pdf_policy(con_id);
      }}
    >
      {l ? "..." : pad(con_id)}
    </Button>
  );
}
